import React, { useEffect, useState, Fragment, useRef } from 'react'
import {Card,Col,Container,Form,Row,Modal,Button} from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { useDispatch, useSelector } from 'react-redux'
import {useFormik} from 'formik'
import { cambiarModoContacto, obtenerDatosUltimoContacto, obtenerGrillaHistorial, obtenerModo, postActualizarContactoAction } from '../../../../store/actions/modal-contacto-tercero-action';
import Historial from './historial';
import { validationSchemas } from '../../../../common/validation-Shemas-modal-contacto';
import { obtenerDatosGestionImplicado } from '../../../../store/actions/gestion-defensa-action';
import { isValidParam } from '../../../../common/Formatos';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../../../api/api-parametros';
import Mensajes from '../../../mensajes'

const DatosTercero = ({showToast, setShowToast, ultimaInstancias, handleShowToast, handleCloseContacto}) => {

  const [loading, setLoading]=useState(false)  
  const fileRef = useRef();
  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
  const { llaves, datosGestionImplicado } = data_gestion_defensa;
   const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
   const { cfg_form15,isModoContactoGlobal,comboModoContactoModal,comboRespuestaContactoModal,respuestaContacto, datosUltimoContacto} = data_modal_contacto
      
   const [codHitoContacto, setCodHitoContacto] = useState('')
   const [minutaHitoContacto, setMinutaHitoContacto] = useState("")
   const [minutaHitoRespuesta, setMinutaHitoRespuesta] = useState("")
   const [fechaHitoContacto, setFechaHitoContacto] = useState("")
   const [fechaHitoRespuesta, setFechaHitoRespuesta] = useState("")
   const [fechaSiniestro, setFechaSiniestro] = useState("")
   const [codHitoRespuesta, setCodHitoRespuesta] = useState("")
   const [fechaUltimoContacto, setFechaUltimoContacto]=useState('')
   const [fechaUltimoRespuesta, setFechaUltimoRespuesta]=useState('')
   const [fechaPrimerContacto, setFechaPrimerContacto]=useState('')
   const [isLimpiar, setIsLimpiar] = React.useState(false)
   const [isModoContacto,setIsModoContacto  ] = React.useState(false);
  const [isModoRespuesta, setIsModoRespuesta] = React.useState(false);
  const [isRespuesta, setIsRespuesta] = React.useState(false);
  const [isContacto, setIsContacto] = React.useState(true);
  const [isChecked, setIsChecked] = React.useState(true);

    
  const [instancias, setInstancias] = React.useState("")

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
  const [showConfirmGrande, setShowConfirmGrande] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

   const dispatch = useDispatch()
 useEffect(()=>{
setIsModoContacto(false)
setIsModoRespuesta(false)
 },[])

 useEffect(() => {
   (async () => {
     const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
     setLimites({ liviano, pesado });
   })();
 }, [])

   
   useEffect(()=>{
    if(isLimpiar){
      setIsModoContacto(false)
      setCodHitoContacto('')
      setMinutaHitoContacto('')
      setCodHitoRespuesta('')
      setFechaHitoContacto('')
      setFechaHitoRespuesta('')
      setMinutaHitoRespuesta('')
    }
    setIsLimpiar(false)
   },[isLimpiar])

  useEffect(() => {
    //console.log("fecInstanciaGesFormat: ", datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['fecInstanciaGesFormat']);
    setFechaHitoContacto(      
        datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] && 
        isValidParam(datosGestionImplicado.datosGestionImplicado[0]['fecInstanciaGesFormat']) ? convertirFecha(datosGestionImplicado.datosGestionImplicado[0]['fecInstanciaGesFormat']) : hoy()
    )   
    setFechaHitoRespuesta(    
        datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] && 
        isValidParam(datosGestionImplicado.datosGestionImplicado[0]['fechaHitoRespuestaFormat']) ? convertirFecha(datosGestionImplicado.datosGestionImplicado[0]['fechaHitoRespuestaFormat']) : hoy()
    )   
    setCodHitoRespuesta(
        datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] && 
        isValidParam(datosGestionImplicado.datosGestionImplicado[0]['codHitoRespuesta']) ? datosGestionImplicado.datosGestionImplicado[0]['codHitoRespuesta'] : ''
    )   
    setFechaSiniestro(
        datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] && 
        isValidParam(datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat']) ? datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat'] : ''
    )   
  }, [datosGestionImplicado])


  useEffect(()=>{
    setFechaUltimoContacto(
      datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] && 
        isValidParam(datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat']) ? convertirFecha(datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat']) : ''
      )
    setFechaUltimoRespuesta(
      datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] && 
        isValidParam(datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat']) ? convertirFecha(datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat']) : ''
      )
     setFechaPrimerContacto(
      datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] && 
        isValidParam(datosUltimoContacto.datosUltimoContacto[0]['fechaPrimerContactoFormat']) ? convertirFecha(datosUltimoContacto.datosUltimoContacto[0]['fechaPrimerContactoFormat']) : ''
      )
  },[datosUltimoContacto])

  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined){
      
      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')
  
      return fechaFormat
    }else return null
  }
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAction = (action) => {
    console.log(action);
  };
  const hoy = () => {
    const fecha = new Date()
    const hoy = fecha.toISOString().split('T')[0]
    return hoy
  }
  const historialF=()=>{
        
    if (llaves && datosGestionImplicado) {
   
     let query = Buffer.from(JSON.stringify({
         idCaso: llaves && llaves["idCaso"],
         idImplicado: llaves && llaves["idImplicado"],
         idModoIngreso1: 238011,
         idModoIngreso2: 238012,
         tipoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'],
         ambitoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'],
         responsableReasignado: false
     })).toString('base64')
     dispatch(obtenerGrillaHistorial(query))
 }
  
  }
const formik = useFormik({
    initialValues: {
        "idCaso": "",
        "idImplicadoCaso": "",
        "idOrganizacion": "",
        "idCarpetaResExt": null,
        "codTipoGestion": "",
        "codAmbitoGestion": "",
        "glosaAmbitoGestion": null,
        "codIntanciaGestion": null,
        "fechaAudiencia": null,
        "codHitoContacto": "",
        "fechaHitoContacto": "",
        "minutaHitoContacto": "",
        "codHitoRespuesta": "",
        "fechaHitoRespuesta": "",
        "minutaHitoRespuesta": "",
        "recepciona": "0",
        "aliasApp": null,
        "idUsuario": ""


    },
     validationSchema: validationSchemas(isModoContacto, isModoRespuesta, isContacto),
    onSubmit: async (formData) => {
        const dataForm = {
            ...formData
        }
        dataForm["idCaso"] = llaves && llaves["idCaso"]
        dataForm["idImplicadoCaso"] = llaves && llaves["idImplicado"]
        dataForm["idOrganizacion"] = llaves && llaves["idOrgCaso"]
        dataForm["idUsuario"] = llaves && llaves["idUsuario"]
        dataForm["codTipoGestion"] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codTipoGestion"]
        dataForm["codAmbitoGestion"] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codAmbitoGestion"]


        setLoading(true)
        if(formData.file){
          if (esArchivoGrande(formData.file, limites.liviano)) {
            try {
              let archivoRef;
              if (archivoSubidoRef.current.file === formData.file) {
                archivoRef = archivoSubidoRef.current;
              } else {
                archivoRef = await subirArchivoGrandeS3(formData.file);
                archivoSubidoRef.current = { file: formData.file, ...archivoRef };
              }
              let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "s3Bucket": archivoRef.s3Bucket, "s3Key": archivoRef.s3Key };
              submitConDatos(data, formData)
            } catch (error) {
              setLoading(false);
              console.error(error.message);
              alert(error.message);
            }
          } else {
            getBase64(formData.file).then((base64data) => {

              // Data requerida para cargar archivo. Utilizamos sintaxis spread (...) para concatenar valores de user y datos de archivo.
              const fileData=base64data.split(',')[1]
              let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "base64data": fileData };
              submitConDatos(data, formData)
            })
          }
        }else{
          dispatch(postActualizarContactoAction(dataForm)).then(()=>historialF()).then(()=>getUltimoContacto())
          .then(()=>UpdateUltimoHito())
          .then(()=>{
            handleShowToast()
            setIsLimpiar(true)
            setLoading(false)
          })
        }



    }
})
const submitConDatos=(data, formData)=>{
  dispatch(postActualizarContactoAction(data)).then(()=>historialF()).then(()=>getUltimoContacto())
  .then(()=>UpdateUltimoHito())
  .then(()=>{
    handleShowToast()
    setIsLimpiar(true)
    setLoading(false)
    if (fileRef.current) fileRef.current.value = "";
    formik.touched.file=false
    archivoSubidoRef.current = { file: null, s3Bucket: null, s3Key: null };
  }).then(()=>{
    delete formData['file']
  })
  .catch((error) => {
    setLoading(false);
    console.error(error.message);
    alert(error.message);
  });
}
const handleFileChange = (e) => {
  const file = e.currentTarget.files[0];
  if (!file) return;
  if (file.size > limites.pesado) {
    alert(`El archivo no puede superar ${limites.pesado / 1000000}MB.`);
    e.currentTarget.value = "";
    return;
  }
  if (esArchivoGrande(file, limites.liviano)) {
    setPendingFile(file);
    setShowConfirmGrande(true);
  } else {
    formik.setFieldValue("file", file);
  }
}
const handleCancelArchivoGrande = () => {
  setPendingFile(null);
  if (fileRef.current) fileRef.current.value = "";
  setShowConfirmGrande(false);
}
const handleConfirmArchivoGrande = () => {
  formik.setFieldValue("file", pendingFile);
  setShowConfirmGrande(false);
}
const UpdateUltimoHito=()=>{
    if (llaves) {

      let query = Buffer.from(
        JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
      ).toString('base64')
      dispatch(obtenerDatosGestionImplicado(query))
    }
  }
const getUltimoContacto=()=>{
    if (llaves) {
        let query = Buffer.from(
          JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
        ).toString('base64')
        dispatch(obtenerDatosUltimoContacto(query))
      }
}
const handleChange=(e)=> {
  setIsModoContacto(false)
  setIsModoRespuesta(false)
  if (e.target.value==2) {
    dispatch(obtenerModo(2))
    setIsContacto(false)
    setCodHitoContacto('')
    //setFechaHitoContacto(hoy())
    setMinutaHitoContacto('')
  } else {
    dispatch(obtenerModo(1))
    setIsContacto(true)
    setCodHitoRespuesta('')
    //setFechaHitoRespuesta(hoy())
    setMinutaHitoRespuesta('')
  }
  setIsChecked(!isChecked)
}
const handleCloseToast = () => {
  setShowToast(false);
}
  return (
    <>
 <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
    </style>
    
    
   
    
      
    <LoadingComponent show={loading}/>
    <Form onSubmit={
                    formik.handleSubmit
                }>
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form15 && datosGestionImplicado
              ? cfg_form15.cfg_form15['contactotercero-title-contactoter']
              : ''} {"- "}{datosGestionImplicado &&
                datosGestionImplicado.datosGestionImplicado[0]['nombreImplicado'] !== undefined &&
                datosGestionImplicado.datosGestionImplicado[0]['nombreImplicado'] !== null &&
                datosGestionImplicado.datosGestionImplicado[0]['nombreImplicado'] !== ''
                ? datosGestionImplicado.datosGestionImplicado[0]['nombreImplicado']
                : ''}
          </Card.Header>
          <Container>
            <Container>
            
              {cfg_form15? (
                <div>
                  <Row className='mt-4'>
                  <Col md="4">
                    <Form.Check label={cfg_form15.cfg_form15['contactotercero-title-contactoter']} name="group1" type='radio' id='contacto' value={1}
                                                  checked={isChecked}
                                                  onChange={
                                                      (e) => handleChange(e)
                                                  }/>
                  </Col>
                  <Col md="4">
                    <Form.Check label={cfg_form15.cfg_form15['contactotercero-radio-respuesta']} name="group1" type='radio' id='respuesta' value={2}
                                                  
                                                  onChange={
                                                    (e) => handleChange(e)
                                                  }/>
                  </Col>
                  </Row>
                  <Row className='mt-4'>
                  

                 
                    <Col md="4">
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {isContacto ?
                          cfg_form15.cfg_form15[
                            'contactotercero-cmb-modocto'
                          ]:cfg_form15.cfg_form15[
                            'contactotercero-cmb-respuestacto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'                       
                        onChange={(e) => {
                          formik.handleChange(e)
                          if(isContacto){
                            setCodHitoContacto(e.target.value) 
                            if(e.target.value!==''){
                              setIsModoContacto(true)
                            }else{
                              setIsModoContacto(false)
                            }
                          }else{
                            setCodHitoRespuesta(e.target.value)
                            if(e.target.value===''){
                              setIsModoRespuesta(false)
                            }else{
                              setIsModoRespuesta(true)
                            }
                          }
                       
                        }}
                        name={isContacto?'codHitoContacto':'codHitoRespuesta'}
                        value={isContacto?(formik.values.codHitoContacto = codHitoContacto):(formik.values.codHitoRespuesta = codHitoRespuesta)}
                        error={isContacto? formik.errors.codHitoContacto:formik.errors.codHitoRespuesta }
                      >
                        <option value={''}>Seleccione...</option>
                        {isContacto ? comboModoContactoModal &&
                          comboModoContactoModal.comboModoContactoModal?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          )):comboRespuestaContactoModal &&
                          comboRespuestaContactoModal.comboRespuestaContactoModal?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {isContacto ? formik.errors.codHitoContacto ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.codHitoContacto}
                    </Form.Text>
                  ) : (
                    ''
                  ):
                  formik.errors.codHitoRespuesta ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.codHitoRespuesta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                     
                     
                    </Col>
                    <Col md="2">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {isContacto ?
                          cfg_form15.cfg_form15[
                            'contactotercero-input-fechacto'
                          ]:cfg_form15.cfg_form15[
                            'contactotercero-input-fecharesp'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Control
                    className='mb-0'
                   
                    type='date'
                   value={isContacto?(formik.values.fechaHitoContacto = fechaHitoContacto):(formik.values.fechaHitoRespuesta = fechaHitoRespuesta)}
                    min={isContacto ? fechaUltimoContacto !=='' && fechaUltimoContacto !==null && fechaUltimoContacto !==undefined 
                      ? convertirFecha(fechaUltimoContacto && fechaUltimoContacto) : fechaSiniestro && convertirFecha(fechaSiniestro && fechaSiniestro)
                      :
                      fechaUltimoRespuesta !=='' && fechaUltimoRespuesta !==null && fechaUltimoRespuesta !==undefined ? fechaUltimoRespuesta :
                      fechaPrimerContacto && fechaPrimerContacto!=='' &&  fechaPrimerContacto!==null &&  fechaPrimerContacto!==undefined 
                      ? convertirFecha(fechaUltimoContacto && fechaUltimoContacto) : fechaSiniestro && convertirFecha(fechaSiniestro)
                    }
                     max={hoy()}
                    name={isContacto ? 'fechaHitoContacto': 'fechaHitoRespuesta'}
                    onChange={(e) => {
                      formik.handleChange(e)
                      if(isContacto){
                        setFechaHitoContacto(e.target.value)
                       
                      }
                      else{
                        setFechaHitoRespuesta(e.target.value)
                      }
                    }}
                     error={isContacto ?formik.errors.fechaHitoContacto: formik.errors.fechaHitoRespuesta}
                  ></Form.Control>
                  {isContacto ? formik.errors.fechaHitoContacto &&  isModoContacto? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fechaHitoContacto}
                    </Form.Text>
                  ) : (
                    ''
                  ):
                  formik.errors.fechaHitoRespuesta &&  isModoRespuesta? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fechaHitoRespuesta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                     
                     
                    </Col>
                    <Col md="5">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {isContacto ?
                          cfg_form15.cfg_form15[
                            'contactotercero-input-comentariocto'
                          ]:cfg_form15.cfg_form15[
                            'contactotercero-input-comentarioresp'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Control
                          as='textarea'
                          className='mb-2'
                          rows={2}
                          onChange={(e) => {
                            formik.handleChange(e)
                            if(isContacto){

                              setMinutaHitoContacto(e.target.value)
                            }
                            else{
                              setMinutaHitoRespuesta(e.target.value)

                            }
                          }}
                          name={isContacto?'minutaHitoContacto':'minutaHitoRespuesta'}
                          value={isContacto ?
                            (formik.values.minutaHitoContacto = minutaHitoContacto)
                            :(formik.values.minutaHitoRespuesta = minutaHitoRespuesta)
                          }
                          error={isContacto? (formik.values.minutaHitoContacto = minutaHitoContacto):(formik.values.minutaHitoRespuesta = minutaHitoRespuesta)}
                        />
                      
                     
                    </Col>

                   
                  </Row>
                  <Row>
                    <Col md='11'>
                    <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {isContacto ?
                          cfg_form15.cfg_form15[
                            'contactotercero-lbl-subirdctocto'
                          ]:cfg_form15.cfg_form15[
                            'contactotercero-lbl-subirdctoresp'
                          ]
                        }
                      </Form.Label>
                      <Form.Group className="position-relative mb-2 mt-1">
                      <Form.Control ref={fileRef} type="file" name="file"
                          onChange={handleFileChange} onBlur={formik.handleBlur}
                          isInvalid={!!formik.errors.file}
                          isValid={formik.touched.file && !formik.errors.file}
                      />
                      <Form.Text className="text-muted">{`Tamaño máximo del archivo: ${limites.pesado / 1000000}MB`}</Form.Text>
                      <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  
                  </Row>
                  
                  
                 
                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                <Row>
                  <Col md="8">
                  
                  </Col>
                  <Col>
                      {respuestaContacto && 
                          <Mensajes
                              showToast={showToast}
                              handleCloseToast={handleCloseToast}
                              delay={5000}
                              responseData={respuestaContacto.respuestaContacto}
                          ></Mensajes>
                        }
                  </Col>
                </Row>
                </div>
              ) : null}
            </Container>
   
          </Container>
        </Card>
        <Historial handleCloseContacto={handleCloseContacto}
            formik={formik}
            setInstancias={setInstancias}
            instancias={instancias}
            submitLoading={loading}

        />
        </Form>
        <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md' centered>
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                    Confirmación
                </Card.Header>
                <Card.Body>
                    {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                </Card.Body>
                <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                    <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                </Card.Footer>
            </Card>
        </Modal>
    </>
  )
}

export default DatosTercero

const getBase64 = (file) => {
  return new Promise(resolve => {
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      reader.onload = () => {
          resolve(reader.result);
      };
  });
};